/**
 * Constructor to create the custom placeholder on the input element.
 * @constructor
 * @see the ticket RTDEV-10616
 */
com.inq.ui.CustomPlaceholder = function(parent) {
	this._parent = parent;
	this._element = parent._element;
	this._value = "";
	this._placeholder = null;

	this.initialize();
};
$hxClasses.extend(com.inq.ui.CustomPlaceholder, com.inq.ui.CustomPlaceholder, "com.inq.ui.CustomPlaceholder");

com.inq.ui.CustomPlaceholder.prototype.show = function() {
	this._placeholder.style.display = "block";
};

com.inq.ui.CustomPlaceholder.prototype.hide = function() {
	this._placeholder.style.display = "none";
};

com.inq.ui.CustomPlaceholder.prototype.toggle = function() {
	if (this._element.value == "") {
		this.show();
	} else {
		this.hide();
	}
};

com.inq.ui.CustomPlaceholder.prototype.getValue = function() {
	return this._value;
};

com.inq.ui.CustomPlaceholder.prototype.setValue = function(value) {
	this._value = value;
	this._placeholder.innerHTML = value;
};

com.inq.ui.CustomPlaceholder.prototype.initialize = function() {
	this._placeholder = document.createElement("span");

	if(com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
		haxe.Timer.delay(this.applyStyles.bind(this),500);
	} else {
		this.applyStyles();
	}

	this._element.parentNode.insertBefore(this._placeholder, this._element);

	this.setupListeners();
	this.toggle();
};

com.inq.ui.CustomPlaceholder.prototype.applyStyles = function () {
	this._placeholder.style.position = "absolute";
	this._placeholder.style.color = "#aaa";
	this._placeholder.style.fontSize = (window.getComputedStyle && window.getComputedStyle(this._element).fontSize) || this._element.currentStyle && this._element.currentStyle["fontSize"];
	this._placeholder.style.fontFamily = (window.getComputedStyle && window.getComputedStyle(this._element).fontFamily) || this._element.currentStyle && this._element.currentStyle["fontFamily"];

};

/**
 * IE8 (and lower): "keyup" is needed to trigger event after every keystroke
 *					"propetychange" is needed to trigger event after first keydown if it's repeating
 *					("propetychange" doesn't trigger only after input of first character)
 *					"paste" is needed for "onpaste" event by mouse's click
 *					"cut" is needed for "oncut" event by mouse's click
 * @see the ticket RTDEV-11345
 */
com.inq.ui.CustomPlaceholder.prototype.setupListeners = function() {
	com.inq.utils.Capabilities.BindListener(this._element, "input", $bind(this, this.toggle));

	var ieVersion = com.inq.utils.Util.getIEMajorVer(true);
	if (0 < ieVersion && ieVersion <= 8) {
		com.inq.utils.Capabilities.BindListener(this._element, "propertychange", $bind(this, this.toggle));
		com.inq.utils.Capabilities.BindListener(this._element, "keyup", $bind(this, this.toggle));
		com.inq.utils.Capabilities.BindListener(this._element, "paste", $bind(this, this._onCut));
		com.inq.utils.Capabilities.BindListener(this._element, "cut", $bind(this, this._onCut));
	} else if (ieVersion == 9) {
		com.inq.utils.Capabilities.BindListener(this._element, "keyup", $bind(this, this._onKeyup));
		com.inq.utils.Capabilities.BindListener(this._element, "cut", $bind(this, this._onCut));
	}
};

com.inq.ui.CustomPlaceholder.prototype._onKeyup = function(ev) {
	if (!ev) {
		ev = Application.application.getPanelWindow().event;
	}

	if (ev.keyCode == com.inq.ui.Keyboard.BACKSPACE || ev.keyCode == com.inq.ui.Keyboard.DELETE) {
		this.toggle();
	}
};

com.inq.ui.CustomPlaceholder.prototype._onCut = function(ev) {
	var _this = this;
	setTimeout(function() {
		_this.toggle();
	}, 0);
};
